// Footer.js
import React from 'react';
import { Typography, Link, Box, useTheme } from '@mui/material'; // Import useTheme

function Footer() {
  const year = new Date().getFullYear();
  const theme = useTheme(); // Use the theme hook

  return (
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper, // Use theme paper background
        color: theme.palette.text.secondary, // Use theme secondary text color
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
          },
      }}
    >
          <Typography variant="body2" color="inherit"> {/* Inherit color from Box */}
              © {year},
              <Link href="https://kloneit.net" color="inherit" target="_blank" rel="noopener noreferrer">
                 <strong>KlonIT</strong>
              </Link>
               . All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: theme.spacing(2), [theme.breakpoints.down('sm')]: {
              marginTop: theme.spacing(1),
             } }}>
              <Link href="/support" variant="body2" color="inherit">Support</Link>
              <Link href="/help" variant="body2" color="inherit">Help Center</Link>
              <Link href="/privacy" variant="body2" color="inherit">Privacy</Link>
              <Link href="/terms" variant="body2" color="inherit">Terms</Link>
              <Link href="/wordpress-plugin" variant="body2" color="inherit">Wordpress Plugin</Link>
              <Link href="https://docs.klonit.ai/" variant="body2" color="inherit" target="_blank" rel="noopener noreferrer">Documentation</Link>
          </Box>
      </Box>
  );
}

export default Footer;